module.exports = __webpack_public_path__ + "static/media/14.8c044fae.png";